const StokeArrowUp = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...props}>
      <path d="M12 9.83301L8 5.83301L4 9.83301L12 9.83301Z" fill="#0A0A0A" stroke="#0A0A0A" strokeLinejoin="round" />
    </svg>
  );
};

export default StokeArrowUp;
